export class Category {
    Id: number;
    Name: string;
    Status: number;
    ApplicationId: number;
}
export class Business {
    Id: number;
    Name: string;
}